import { useNavigate } from "react-router-dom";
import classes from "./Banner.module.css";
import { requestBookCall } from "../../lib/bookCall";
import site, { heroSrcSet } from "../../data/site";

function Banner() {
  const navigate = useNavigate();
  const sizes = site.hero.sizes;

  return (
    <section className={classes.hero} id="home">
      <div className={classes.copy}>
        <p className={classes.brand}>DigitaliNation</p>
        <h1 className={classes.headline}>
          Software, marketing, and operations that help you grow.
        </h1>
        <p className={classes.support}>
          We design, build, and run the digital work your business needs to win
          customers. Fully remote, based in Islamabad, Pakistan, and working
          with clients worldwide.
        </p>
        <div className="ctaRow">
          <button
            type="button"
            className="buttonHome"
            onClick={() => requestBookCall(navigate)}
          >
            Book a Call
          </button>
          <a className="buttonHomeOutline" href="#services">
            Our Services
          </a>
        </div>
      </div>
      <div className={classes.visual}>
        <picture>
          <source type="image/avif" srcSet={heroSrcSet("avif")} sizes={sizes} />
          <source type="image/webp" srcSet={heroSrcSet("webp")} sizes={sizes} />
          <img
            src="/hero/hero-1280.webp"
            srcSet={heroSrcSet("webp")}
            sizes={sizes}
            alt={site.hero.alt}
            width="1709"
            height="1059"
            fetchpriority="high"
            decoding="async"
            className={classes.image}
          />
        </picture>
      </div>
    </section>
  );
}

export default Banner;
